<template>
  <CustomTooltip :message="tooltipMessage" position="bottom" size="small">
    <AppIcon
      :name="iconName"
      :size="iconSize"
      :class-name="iconClass"
      @click="onClick"
      :clickable="true"
    />
  </CustomTooltip>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import CustomTooltip from '@/components/common/tooltip/CustomTooltip.vue';
import type { IconName, IconSize } from '@/models/icon-types';

const props = defineProps<{
  iconName: IconName;
  tooltipMessage: string;
  iconSize?: IconSize;
  iconClass?: string;
}>();

const iconSize = computed(() => props.iconSize ?? 'body-xl');
const iconClass = computed(() => props.iconClass ?? 'color-lighter');

const emit = defineEmits(['click']);

function onClick() {
  emit('click');
}
</script>
